<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="SoftSkillEnum.Communiquant" i18n>Communicant·e</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Autonome" i18n>Autonome</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Flexible" i18n>Flexible</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Perseverant" i18n>Persévérant·e</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Positif" i18n>Positif·ve</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Creatif" i18n>Créatif·ve</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Convaincant" i18n>Convaincant·e</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Innovant" i18n>Innovant·e</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.EspritEquipe" i18n>Esprit d'équipe</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Curieux" i18n>Curieux·se</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Reactif" i18n>Réactif·ve</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Rigoureux" i18n>Rigoureux·se</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.EspritAnalyse" i18n>Esprit d'analyse</ng-container>
  <ng-container *ngSwitchCase="SoftSkillEnum.Entreprenant" i18n>Entreprenant·e</ng-container>
  <ng-container *ngSwitchDefault>{{ model }}</ng-container>
</ng-container>
